import React, { useEffect } from 'react';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
} from "@/components/ui/select"

export default function XAxisMetricsSelection({ initialValue, onSetMetric, metricOptions = [] }) {
  const [selectedValue, setSelectedValue] = React.useState(initialValue?.value);

  // Update selected value when initialValue changes
  React.useEffect(() => {
    if (initialValue?.value) {
      setSelectedValue(initialValue.value);
    }
  }, [initialValue]);

  const handleValueChange = (v) => {
    // console.log("selected value is ",v)
    if (!v) return;
    const matchingMetric = metricOptions.find(m => m.value === v);
    if (matchingMetric) {
      // console.log("matching metric is ",matchingMetric)
      setSelectedValue(v);
      onSetMetric({
        metric: matchingMetric.label,
        value: matchingMetric.value
      });
    }
    };
  
  // console.log()
  return (
    <Select
      value={selectedValue}
      onValueChange={(v)=>handleValueChange(v)}
    >
      <SelectTrigger className="w-[180px] bg-background text-foreground border border-border rounded-lg">
        <SelectValue>
          {metricOptions.find(m => m.value === selectedValue)?.label || "Select Metric"}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-60 overflow-y-auto bg-background text-foreground border border-border">
        <SelectGroup>
          <SelectLabel>X-Axis Metric</SelectLabel>
          {metricOptions.map((item) => (
            <SelectItem key={item.value} value={item.value} className="text-foreground">
              {item.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
} 